import { render, staticRenderFns } from "./RegistrationSidebar.vue?vue&type=template&id=172bd9bc"
import script from "./RegistrationSidebar.vue?vue&type=script&lang=js"
export * from "./RegistrationSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports